<template>
  <div>
    <a-breadcrumb>
      <a-breadcrumb-item>系统设置</a-breadcrumb-item>
      <a-breadcrumb-item>项目轮次管理</a-breadcrumb-item>
    </a-breadcrumb>
    <div class="space-20">
      <a-button type="primary" @click="addRound">新增</a-button>
    </div>
    <a-table :loading="loading" :columns="columns" :dataSource="list" :rowKey="row => row.id">
      <span slot="action" slot-scope="row">
        <a-button @click="editRound(row)" size="small">编辑</a-button>
        <a-divider type="vertical" />
        <a-button v-if="row.status === 0" @click="changeRoundStatus(row)" size="small" type="danger">禁用</a-button>
        <a-button v-else @click="changeRoundStatus(row)" size="small" type="primary">启用</a-button>
      </span>
    </a-table>
    <a-modal :title="title" @cancel="closeModel" :visible="showModel === 'addRound' || showModel === 'edidRound'" width="400px">
      <a-form-model ref="roundInfo" :model="roundInfo" :rules="rules" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
        <a-form-model-item label="轮次名称：" ref="name" prop="name" v-if="showModel === 'addRound'">
          <a-input v-model="roundInfo.name" placeholder="轮次名称"></a-input>
        </a-form-model-item>
        <a-form-model-item label="描述：" ref="desc" prop="desc">
          <a-input v-model="roundInfo.desc" placeholder="描述"></a-input>
        </a-form-model-item>
        <a-form-model-item label="排序：" ref="sort" prop="sort">
          <a-input v-model="roundInfo.sort" placeholder="请填写一个数字"></a-input>
        </a-form-model-item>
      </a-form-model>
      <template slot="footer">
        <a-button @click="closeModel">取消</a-button>
        <a-button type="primary" @click="handleRound(showModel)">确定</a-button>
      </template>
    </a-modal>
  </div>
</template>
<script>
import { roundList, roundManage } from '@/api/round.js';
const columns = [
  { title: '项目轮次id', dataIndex: 'id', align: 'center' },
  { title: '项目轮次', dataIndex: 'name', align: 'center' },
  { title: '描述', dataIndex: 'desc', align: 'center' },
  { title: 'RankScore', dataIndex: 'sort', align: 'center' },
  { title: '操作', align: 'center', scopedSlots: { customRender: 'action' } }
];
export default {
  data() {
    return {
      loading: true,
      columns,
      list: [],
      showModel: '',
      roundInfo: {
        name: '',
        desc: '',
        sort: ''
      },
      rules: {
        name: [{ required: true, message: '请输入轮次名称', trigger: 'blur' }],
        sort: [{ pattern: /^\d+(\.\d+)?$/g, message: '请填写一个数字', trigger: 'change' }]
      },
      title: ''
    };
  },
  methods: {
    closeModel() {
      this.showModel = '';
    },
    async getList() {
      this.loading = true;
      try {
        let res = await roundList();
        this.loading = false;
        if (res.code === 200) {
          this.list = res.data;
        }
      } catch (err) {
        console.log(err);
      }
    },
    editRound(row) {
      this.showModel = 'edidRound';
      this.title = '编辑项目轮次';
      this.roundInfo = { ...row };
    },
    addRound() {
      this.showModel = 'addRound';
      this.roundInfo = { name: '', desc: '', sort: '' };
      this.title = '新增项目轮次';
    },
    async handleRound(type) {
      try {
        let data = {};
        if (type === 'addRound') {
          data = { type: 1, ...this.roundInfo };
        } else if (type === 'edidRound') {
          data = { type: 2, id: this.roundInfo.id, desc: this.roundInfo.desc, sort: this.roundInfo.sort };
        }
        let res = await roundManage(data);
        if (res.code === 200) {
          this.closeModel();
          this.getList();
          this.$message.success('success');
          !data.id && (this.roundInfo = { name: '', desc: '', sort: '' });
        } else {
          this.$message.error(res.msg);
        }
      } catch (err) {
        console.log(err);
      }
    },
    async changeRoundStatus(row) {
      this.$confirm({
        title: `${row.status === 0 ? '确定禁用' : '确定启用'}轮次：${row.name}吗?`,
        okText: '确定',
        okType: 'danger',
        cancelText: '取消',
        onOk: () => {
          let data = { type: row.status === 0 ? 3 : 4, id: row.id };
          roundManage(data).then(res => {
            if (res.code === 200) {
              this.$message.success('success');
              this.getList();
            } else {
              this.$message.error(res.msg);
            }
          });
        }
      });
    }
  },
  mounted() {
    this.getList();
  }
};
</script>
